import { useState, useContext } from "react";
import { createPortal } from "react-dom";
// import { headerLinks } from "utils/home-page-data";
import { NavLink,useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LangContext } from "context/language";
import logoBlue from "assets/images/logo-colored.png"

import {
  motion,
  useScroll,
  useMotionValueEvent,
  AnimatePresence,
} from "framer-motion";
import CloseIconSVG from "assets/svg/close-icon";
import SearchIconSVG from "assets/svg/search-icon";
import Button from "components/button/button";
import MenuFlatIconSVG from "assets/svg/menu-icon";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import {
  REFRESH_SEARCH_PROFILE
} from "redux/modules/search-profile/types";

export default function Header() {
  const [isHidden, setIsHidden] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const { scrollY } = useScroll();
  const [show, setShow] = useState(false);
  const {t} = useTranslation();
  const {headerLinks} = useContext(LangContext)
  const dispatch = useDispatch();
  const history = useHistory();
  const [search, setSearch] = useState("");


  // Listen to scroll changes and detect direction
  useMotionValueEvent(scrollY, "change", (latest) => {
    const previous = scrollY.getPrevious();
    if (latest > previous && latest > 50) {
      // Scrolling down and past a threshold (e.g., 50px)
      setIsHidden(true);
      setShowSearch(false);
    } else if (latest < previous) {
      // Scrolling up

      setIsHidden(false);
    }
  });

  const handleRedirectFaqs = () => {
    window.location.href = 'https://milestonespage.com/faqs/';
  };

  const handleOnSearch = async (e) => {
      e.preventDefault();
      if (!_.isEmpty(search)) {
        dispatch({
            type: REFRESH_SEARCH_PROFILE,
            payload: [],
          });
        window.location.href = `${process.env.REACT_APP_PUBLIC_DOMAIN}/search?keyword=${search}`;
      }
    };
  

  return (
    <>
      <motion.div
        initial={{ y: 0 }}
        animate={{ y: isHidden ? "-100%" : 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="h-20 flex flex-col justify-center sticky top-0 bg-white z-50 overflow-visible"
      >
        <div className="px-6">
          <div className="h-20 bg-white container max-w-[100rem] flex flex-row gap-4 justify-between m-auto z-[2] relative">
            <div className="flex flex-row items-center gap-4">
              <button
                className="md:hidden flex items-center justify-center"
                onClick={() => setShow(true)}
              >
                <svg
                  width="26"
                  height="12"
                  viewBox="0 0 26 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1.2002H25"
                    stroke="#004364"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M1 6H25"
                    stroke="#004364"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M1 10.8003H25"
                    stroke="#004364"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>

              <div className="flex flex-row items-center gap-8 lg:gap-14">
                <div className="aspect-[3.125/1.25] w-[8rem] lg:w-[11.75rem] relative">
                  <img
                    // src="https://milestonespage.com/wp-content/uploads/2024/02/milestones-page.svg"
                    src={logoBlue}
                    alt="Milestone Logo"
                    className="object-contain absolute inset-0 w-full h-full"
                  />
                </div>

                <ul className="hidden md:flex flex-row items-center gap-4 lg:gap-10 font-medium lg:text-base text-sm text-neutral-800">
                  {headerLinks.map((link) => (
                    <li key={link.id}>
                      {
                        (link.id === 4 || link?.path.includes('faqs')) ?
                        <button onClick={handleRedirectFaqs}>{link.label}</button>: 
                        <a href={`https://milestonespage.com${link.path}`}>{link.label}</a>
                      }
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="flex flex-row items-center gap-4">
              <button
                className="select-none outline-none"
                onClick={() => setShowSearch((s) => !s)}
              >
                {showSearch ? (
                  <CloseIconSVG className="outline-none pointer-events-none" />
                ) : (
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="outline-none pointer-events-none"
                  >
                    <path
                      d="M9.27877 17.2849C11.2404 17.2944 13.1409 16.6026 14.6373 15.3342L19.6433 20.3401C19.7839 20.4804 19.9736 20.5605 20.1722 20.5634C20.3702 20.5581 20.5591 20.4784 20.701 20.3401C20.8367 20.1998 20.9125 20.0123 20.9125 19.8172C20.9125 19.622 20.8367 19.4345 20.701 19.2943L15.695 14.3354C16.917 12.8755 17.6045 11.0424 17.644 9.1389C17.6836 7.23542 17.0727 5.37541 15.9123 3.866C14.7519 2.3566 13.1113 1.28805 11.2616 0.836912C9.41185 0.385773 7.46357 0.579003 5.73849 1.38465C4.01341 2.1903 2.61473 3.56017 1.77339 5.26809C0.932045 6.97601 0.69833 8.91981 1.11095 10.7785C1.52357 12.6371 2.55778 14.2994 4.0428 15.4909C5.52781 16.6824 7.37482 17.3318 9.27877 17.3319V17.2849ZM9.27877 2.00877C10.6417 1.99716 11.9774 2.39025 13.1167 3.13824C14.256 3.88623 15.1478 4.95546 15.679 6.21058C16.2103 7.4657 16.3571 8.85022 16.1009 10.1888C15.8447 11.5275 15.197 12.7599 14.2399 13.7302C13.2828 14.7005 12.0592 15.365 10.7242 15.6395C9.38919 15.9139 8.0027 15.786 6.7404 15.272C5.47809 14.758 4.3967 13.881 3.63318 12.752C2.86966 11.623 2.45835 10.2929 2.45132 8.93005C2.45125 7.1139 3.16873 5.37123 4.44746 4.08153C5.72619 2.79182 7.46263 2.05948 9.27877 2.04399V2.00877Z"
                      fill="#333333"
                      stroke="#333333"
                      stroke-width="0.5"
                    />
                  </svg>
                )}
              </button>
              <a
                href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/sign-up`}
                className="h-10 lg:h-[3.125rem] hidden md:flex items-center justify-center px-[1rem] lg:px-[1.875rem] bg-primary rounded-md text-white text-xs md:text-sm font-semibold overflow-hidden cursor-pointer relative before:absolute before:h-full before:left-0 before:top-0 before:bg-black before:w-0 hover:before:w-full before:transition-all before:duration-300"
              >
                <span className="z-10">{t('joinForFree')}</span>
              </a>
              <a
                href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/login`}
                className="h-10 lg:h-[3.125rem] hidden md:flex items-center justify-center px-[1rem] lg:px-[1.875rem] bg-white cursor-pointer rounded-md text-xs lg:text-sm font-semibold border-2 overflow-hidden relative before:absolute before:h-full before:left-0 before:top-0 before:bg-primary before:w-0 hover:before:w-full before:transition-all before:duration-300 transition-all duration-300 hover:text-white outline-none hover:border-primary"
              >
                <span className="z-10">{t('signIn')}</span>
              </a>
            </div>
          </div>
        </div>

        <AnimatePresence>
          {showSearch && (
            <motion.div
              initial={{
                // opacity: 0,
                translateY: "-100%",
              }}
              animate={{
                translateY: showSearch ? 0 : "-100%",
              }}
              transition={{ ease: "easeInOut" }}
              exit={{
                // opacity: 0,
                translateY: "-100%",
              }}
              className="absolute top-[100%] h-20 bg-white w-full z-[1] flex flex-row items-center px-6"
            >
              <form onSubmit={handleOnSearch} className="w-full">
                <div className=" container max-w-[100rem]  flex flex-row items-center gap-4 md:gap-6 mx-auto">
                    <div className=" relative flex flex-row items-center h-12 md:h-15 flex-1 mx-auto rounded-md">
                      <div className="absolute ml-6">
                        <SearchIconSVG />
                      </div>
                      <input
                        value={search}
                        onChange={(e) => setSearch(e?.target?.value)}
                        className="h-full w-full border border-black/20 pl-13 rounded-md"
                        placeholder={t("search")}
                      />
                    </div>
                  <button onClick={handleOnSearch} className="h-12 md:h-15 flex items-center justify-center px-[1.875rem] bg-primary rounded-md text-white text-sm font-semibold overflow-hidden cursor-pointer relative before:absolute before:h-full before:left-0 before:top-0 before:bg-black before:w-0 hover:before:w-full before:transition-all before:duration-300">
                    <span className="z-10">{t("search")}</span>
                  </button>
                </div>
              </form>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>

      <MobileMenu show={show} setShow={setShow} handleRedirectFaqs={handleRedirectFaqs}/>
    </>
  );
}

function MobileMenu({ show, setShow, handleRedirectFaqs }) {
  const close = () => {
    setShow(false);
  };
  const {headerLinks} = useContext(LangContext);
  const {t} = useTranslation(); 

  return createPortal(
    <AnimatePresence>
      {show && (
        <>
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
            }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black/80 w-full h-full z-[9998] md:hidden"
            onClick={close}
          ></motion.div>
          <motion.div
            initial={{
              opacity: 0,
              translateX: "100%",
            }}
            animate={{
              opacity: 1,
              translateX: 0,
            }}
            exit={{
              opacity: 0,
              translateX: "100%",
            }}
            transition={{ ease: "easeInOut", duration: 0.3 }}
            className="md:hidden fixed top-0 right-0 bottom-0 w-full sm:max-w-[20rem] bg-white z-[9999] overflow-x-hidden overflow-y-hidden"
          >
            <div className="flex flex-row items-start p-6 justify-between gap-4">
              <div className="h-[3.125rem] w-[11.75rem] relative flex-shrink-0">
                <img
                  src="https://milestonespage.com/wp-content/uploads/2024/02/milestones-page.svg"
                  alt="Milestone Logo"
                  className="object-contain absolute inset-0 w-full h-full"
                />
              </div>

              <button onClick={close} className="mt-1">
                <CloseIconSVG className="outline-none pointer-events-none" />
              </button>
            </div>
            <ul className="flex flex-col gap-4 lg:gap-10 font-medium text-base text-neutral-800 p-6">
              {headerLinks.map((link) => (
                <li key={link.id}>
                  {
                    (link.id === 4 || link?.path.includes('faqs')) ?
                    <button onClick={handleRedirectFaqs}>{link.label}</button> :  
                    <a href={`https://milestonespage.com${link.path}`}>{link.label}</a>
                  }
                </li>
              ))}
            </ul>

            <div className="p-6 gap-4 flex flex-col">
              <a
                href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/sign-up`}
                className="h-[3.125rem] flex items-center justify-center px-[1.875rem] bg-primary rounded-md text-white text-sm font-semibold overflow-hidden cursor-pointer relative before:absolute before:h-full before:left-0 before:top-0 before:bg-black before:w-0 hover:before:w-full before:transition-all before:duration-300"
              >
                <span className="z-10">{t('joinForFree')}</span>
              </a>
              <a
                href={`${process.env.REACT_APP_PUBLIC_DOMAIN}/login`}
                className="h-[3.125rem] flex items-center justify-center px-[1.875rem] bg-white cursor-pointer rounded-md text-sm font-semibold border-2 overflow-hidden relative before:absolute before:h-full before:left-0 before:top-0 before:bg-primary before:w-0 hover:before:w-full before:transition-all before:duration-300 transition-all duration-300 hover:text-white outline-none hover:border-primary"
              >
                <span className="z-10">{t('signIn')}</span>
              </a>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
}
